(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('genre-ibq', {
            parent: 'entity',
            url: '/genre-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.genre.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/genre/genresibq.html',
                    controller: 'GenreIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('genre');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('genre-ibq-detail', {
            parent: 'genre-ibq',
            url: '/genre-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.genre.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/genre/genre-ibq-detail.html',
                    controller: 'GenreIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('genre');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Genre', function($stateParams, Genre) {
                    return Genre.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'genre-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('genre-ibq-detail.edit', {
            parent: 'genre-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/genre/genre-ibq-dialog.html',
                    controller: 'GenreIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Genre', function(Genre) {
                            return Genre.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('genre-ibq.new', {
            parent: 'genre-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/genre/genre-ibq-dialog.html',
                    controller: 'GenreIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('genre-ibq', null, { reload: 'genre-ibq' });
                }, function() {
                    $state.go('genre-ibq');
                });
            }]
        })
        .state('genre-ibq.edit', {
            parent: 'genre-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/genre/genre-ibq-dialog.html',
                    controller: 'GenreIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Genre', function(Genre) {
                            return Genre.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('genre-ibq', null, { reload: 'genre-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('genre-ibq.delete', {
            parent: 'genre-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/genre/genre-ibq-delete-dialog.html',
                    controller: 'GenreIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Genre', function(Genre) {
                            return Genre.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('genre-ibq', null, { reload: 'genre-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
